var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-leaf{fill:var(--secondary-color);stroke: none;stroke-miterlimit:10;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.07,35.08v8.61c0,.75-.1.9-.78,1.18l-14.68,6c-.86.35-1.7.73-2.57,1a1.64,1.64,0,0,1-1.05,0c-5.8-2.35-11.6-4.73-17.39-7.09a1,1,0,0,1-.68-1c0-2.76,0-5.52,0-8.28a.57.57,0,0,0-.44-.65c-.47-.15-.91-.35-1.36-.54a.81.81,0,0,1-.39-1.37c.75-1,1.52-2,2.3-3.07a.9.9,0,0,1,.42-.33c2.4-.82,4.8-1.62,7.27-2.44l.52,1.52-5.14,1.73.54.25L26.1,36.5a1,1,0,0,0,.71,0q7.32-3,14.64-6c.12,0,.23-.12.43-.22l-5.14-1.72.5-1.5.51.14c2.14.71,4.28,1.41,6.4,2.15a2.14,2.14,0,0,1,1,.68c.73.9,1.41,1.84,2.1,2.77.49.66.35,1.15-.39,1.47L45.18,35Zm-35.53.63v.61c0,2.18,0,4.37,0,6.55a.76.76,0,0,0,.57.83q7.5,3,15,6.11l.59.22V40l-.79,1c-.43.56-.66.63-1.34.35l-10.3-4.21Zm33.89,0-.6.23L29.46,41.43c-.67.27-.9.2-1.33-.37l-.8-1v10l16.1-6.59ZM7.59,33.16,23.8,39.79l1.42-1.88-.42-.18-10-4.09c-1.8-.74-3.6-1.48-5.41-2.2-.16-.06-.46-.07-.55,0C8.43,32,8,32.56,7.59,33.16ZM44,31.27,27.77,37.9l1.43,1.89,16.21-6.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M25.92,12.18C27.7,9.91,30.21,9,33,8.51A.82.82,0,0,1,34,9a11.6,11.6,0,0,1,.72,6.66A6.52,6.52,0,0,1,31.39,20a12.55,12.55,0,0,1-4.64,1.59c-.74.11-1,0-1.2-.73S25,20.06,24.4,20a8.25,8.25,0,0,1-4.16-1.66,6,6,0,0,1-2.16-5.09,22.48,22.48,0,0,1,.36-2.94.8.8,0,0,1,.91-.75,9.92,9.92,0,0,1,5,1.39A19,19,0,0,1,25.92,12.18Zm6.26.2A52.33,52.33,0,0,0,28,19.64c4.83-1.2,6.37-4.53,4.65-9.43a11.76,11.76,0,0,0-3.92,1.5c-2.37,1.51-2.84,4.24-2.07,7a53.93,53.93,0,0,1,4.2-7.22ZM20.74,13.84l1.05-1.14,2.91,3.13a7.14,7.14,0,0,1,.21-1.24,1.29,1.29,0,0,0-.35-1.37,5.42,5.42,0,0,0-2.95-1.71c-.56-.14-1.13-.22-1.7-.33-.78,4.05.46,6.55,4.58,7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M9.54,12.49a1,1,0,0,1-.66.95,4.16,4.16,0,0,0-2.45,2.44,1,1,0,0,1-.92.67.91.91,0,0,1-.92-.65,4.2,4.2,0,0,0-2.45-2.45,1,1,0,0,1-.67-.92.92.92,0,0,1,.65-.92A4.24,4.24,0,0,0,4.58,9.16a1,1,0,0,1,1.84,0,4.23,4.23,0,0,0,2.49,2.48A1,1,0,0,1,9.54,12.49Zm-2.78,0L5.51,11.27,4.25,12.52,5.5,13.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M51.53,22.16a1,1,0,0,1-.61.94,4.27,4.27,0,0,0-2.53,2.51.92.92,0,0,1-.89.63.94.94,0,0,1-.93-.65,4.18,4.18,0,0,0-2.49-2.48.91.91,0,0,1-.62-.89.94.94,0,0,1,.64-.93,4.13,4.13,0,0,0,2.48-2.49,1,1,0,0,1,1.82,0,4.18,4.18,0,0,0,2.49,2.48A1,1,0,0,1,51.53,22.16Zm-5.31,0,1.27,1.26,1.24-1.24L47.46,21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M25.72,29.5h1.55v4.79H25.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M33,26.27h1.55v4.78H33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M20,31.07H18.45V26.29H20Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M26.44,2V3.61L25,3.74l-.23-1.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M35.6,6.2l-1.17,1-1-1.08,1-1.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M19.53,22.19l-1,1.12L17.4,22.05l1.15-1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M18.53,5,19.9,4l.89,1.36-1.19.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M26.54,24.65,28,24.53l.25,1.6-1.7.14Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M15.45,9.13l1.47.66-.52,1.4-1.55-.45Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M35.34,19.81l1.36.88-1,1.38L34.45,21Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M38.13,17.55l-.6,1.62-1.47-.68.53-1.39Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M23.1,25.78l.45-1.55,1.46.31-.24,1.6Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M16.09,15.66l.32,1.45-1.54.46-.37-1.68Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M20,24.35,20.82,23l1.31.71-.66,1.46Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M29.47,24.22l1.4-.52.67,1.46-1.61.61Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M31.5,3.08,33,3.9l-.85,1.37-1.33-.71Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M23.5,4.05l-1.39.53-.68-1.46L23,2.51Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M37,14.13h1.6l-.12,1.72-1.59-.22Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M36.9,12.59l-.33-1.44,1.55-.48.37,1.69Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M15.47,19.2l1.46-.67.73,1.3-1.35.88Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M37.52,9.05,36,9.73l-.71-1.3,1.34-.88Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M16.28,7.6l1-1.38,1.22,1-.89,1.2Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M29.43,4,28,3.72l.22-1.59,1.67.35Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M34.45,23.29l-1.39,1L32.19,23l1.19-.9Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-leaf",
    d: "M14.37,14.11l.12-1.66,1.59.21L16,14.11Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.bf17afb3c9138a7f07eaff888b70919d.svg";
export { ForwardRef as ReactComponent };